import React from 'react';
const LegalWatermark = () => (
  <div style={{ position:'fixed', top:0, left:0, width:'100vw', height:'100vh', pointerEvents:'none', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', opacity:0.006 }}>
    <div style={{ transform:'rotate(-30deg)', fontSize:'6vw', fontWeight:900, color:'#888', whiteSpace:'nowrap', userSelect:'none' }}>
      MISKULIN TECHNOLOGIES PROPRIETARY
    </div>
  </div>
);
export default LegalWatermark;
